import type { PendingChoice } from "../domain/types/index.js";

export function selectionBannerText(pending: PendingChoice): string {
  if (pending.kind === "caseExclude") return "このPJが終わるまで除外する手札を1枚選ぶ（0枚でも可）";
  if (pending.kind === "cellar") return "捨てる手札を選ぶ（0枚でも可）";
  if (pending.kind === "knowledgeShare") return "山札の上に置く捨て札を1枚選ぶ";
  if (pending.kind === "fieldJudgment") return "公開した施策を使用するか、山札へ戻すか選ぶ";
  if (pending.kind === "meeting") {
    return `${pending.times}回使用する手札の施策を1枚選ぶ（選ばずに確定で中止）`;
  }
  if (pending.kind === "focus") return "引いた施策を手札に加えるか、脇へ置くか選ぶ";
  if (pending.kind === "quality") return "公開したカードを順番に処理する";
  if (pending.kind === "sendoff") return "手札の労働者を1枚廃棄する（0枚でも可）";
  if (pending.kind === "training") return "手札の新卒または中堅を1枚選び、1段階昇格させる（0枚でも可）";
  if (pending.kind === "workerCycle") return "手札を1枚捨てる（0枚でも可）";
  if (pending.kind === "stables") return "手札の労働者を1枚捨てる（0枚でも可）";
  if (pending.kind === "psychologicalCounseling") return "手札の窓際を1枚廃棄し、ベテランを捨て札に加える（PJ限定は選べない）";
  if (pending.kind === "specialTaskTeam") return "手札の窓際を1枚捨てる";
  if (pending.kind === "handDisruption") return `手札から${pending.count}枚を選んで捨てる`;
  return "選択してください";
}
